/* angular:styles/component:css;36536cb22ddd477ff14a4270b9150daf3c3daabb0e474f28c67aa04a2f8694df;/home/johanelfving/Documents/Utveckling/oncore/src/app/layout/app.search.component.ts */
:is() .p-dialog .p-dialog-header {
  display: none;
}
:is() .p-dialog .p-dialog-content {
  padding: 0;
  background: transparent;
}
/*# sourceMappingURL=app.search.component.css.map */
